import { Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators
} from "@angular/forms";
import { WebappService } from "../../../service/webapp.service";
import { AuthenticationService } from "../../../service/authentication.service";
import * as dropin from "braintree-web-drop-in";
@Component({
  selector: "app-wallet-pay",
  templateUrl: "./wallet-pay.component.html",
  styleUrls: ["./wallet-pay.component.scss"]
})
export class WalletPayComponent implements OnInit {
  braintreeIsReady: boolean;
  dropIninstance: any;
  profileid: any;
  walletForm: FormGroup;
  paid_amount: Number;
  walletmoney: any;
  profilelog: any;
  sitesettings: any;
  ad_unit_id:any;
  admin_enable_ads:any;
  constructor(
    private apiservice: WebappService,
    public toastr: ToastrService,
    private fb: FormBuilder,
    private translate: TranslateService,
    private router: Router,
    private settingsservice: AuthenticationService
  ) {
    this.walletForm = this.fb.group({
      add_amount: ["", Validators.required]
    });
    this.settingsservice.getUserinfo().subscribe(res => {
      this.sitesettings = res;
    });
  }

  ngOnInit() {
    this.braintreeIsReady = false;
    this.profilelog = JSON.parse(localStorage.getItem("user"));
    this.profileid = this.profilelog.id;
    this.ad_unit_id = this.profilelog.ad_unit_id;
    this.admin_enable_ads=this.profilelog.admin_enable_ads;

    this.apiservice.profiledetails(this.profileid).subscribe(data => {
      if (data["status"] === "true") {
        this.walletmoney = data["walletmoney"];
      } else {
        this.walletmoney = "0.00";
      }
    });
  }

  addMoney(walletdata) {
    if (this.walletForm.valid) {
      this.profilelog = JSON.parse(localStorage.getItem("user"));
      this.profileid = this.profilelog.id;
      this.paid_amount = walletdata.add_amount;
      const requestData = {
        user_id: this.profileid
      };
      this.apiservice.braintreetoken(requestData).subscribe(data => {
        if (data["status"] === "true") {
          dropin.create(
            {
              authorization: data["clientToken"],
              selector: "#dropin-container",
              flow: "vault"
            },
            (err, dropinInstance) => {
              if (err) {
                this.toastr.error(this.translate.instant("Something went wrong"));
                this.router.navigate(["/wallet"]);
              }
              this.dropIninstance = dropinInstance;
              this.braintreeIsReady = true;
            }
          );
        } else {
          this.toastr.error(this.translate.instant(data["message"]));
          this.router.navigate(["/wallet"]);
        }
      });
    } else {
      this.validateAllFormFields(this.walletForm);
    }
  }

  pay() {
    this.dropIninstance.requestPaymentMethod((err, payload) => {
      if (err) {
        this.toastr.error(this.translate.instant("Something went wrong"));
        this.router.navigate(["/wallet"]);
      } else {
        const walletData = {
          user_id: this.profileid,
          paynonce: payload.nonce,
          amount: this.paid_amount
        };
        this.apiservice.creditwallet(walletData).subscribe(data => {
          if (data["status"] === "true") {
            this.toastr.success(this.translate.instant(data["message"]));
            this.router.navigate(["/wallet-payment-success"]);
          } else {
            this.toastr.error(this.translate.instant(data["message"]));
            this.router.navigate(["/wallet-payment-failure"]);
          }
        });
      }
    });
  }

  numberOnly(event): void {
    const initalValue = event.target.value;
    event.target.value = initalValue.replace(/[^0-9]*/g, '');
    if ( initalValue.trim() !== event.target.value.trim()) {
      event.stopPropagation();
    }
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
}
